import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { resetContactUsFocus, updateUITabViewInfo } from '../../app/appActions';
import { getCorrelationId, isGetHelpSelector } from '../../app/selectors/contactUsSelector';
import { UnAuthSignInLink } from '../presentationalComponents/UnAuthSignInLink';
import {
    initializeToPage,
  toggleUnAuthBranching,
} from '../reduxUpdater/actions/modalitySectionActions';
import { dispatchAlchemyFetchUnAuthSchema } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapStateToProps = (state: IAppState) => {
  return {
    unAuthBranchingEnabled:
      state.ContactState.ModalitySectionState.unAuthBranchingEnabled,
    unAuthSignInResult:
      state.ContactState.ModalitySectionState.unAuthSignInResult,
    showModalitiesStickyFooter:
      state.ContactState.SelfHelpAlchemyState.showModalitiesStickyFooter,
    correlationId: getCorrelationId(state),
    showAsLinkComponent: isGetHelpSelector(state),
    isGetHelp: isGetHelpSelector(state),
  };
};

const mapDispatchToProps = {
  toggleUnAuthBranching,
  dispatchAlchemyFetchUnAuthSchema,
  updateUITabViewInfo,
  resetContactUsFocus,
  initializeToPage,
};

export const UnAuthSignInLinkContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(UnAuthSignInLink, getContactUsStyles));
